module.exports = __webpack_public_path__ + "static/media/dracula.107bfa0b.png";